document.addEventListener("DOMContentLoaded", () => {
  /* Open - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-open-minicart]").on("click", function (event) {
    event.preventDefault();
    /* Act on the event */
    addMiniCart();
  });
  /* Close - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-close-minicart]").on("click", function (event) {
    event.preventDefault();
    /* Act on the event */
    $(".c-cart-pop-mini").removeClass("active");
    $(".c-cart-popup-notification").removeClass("active");
  });
  /* Add note to cart - Minicart Popup */
  /* -------------------------------------------------------------------------------------- */
  $("[js-minicart-popup]").on(
    "click",
    ".js-cart-min-add-note",
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      var note = $(".js-cart-add-note").val();
      updateNoteMiniCart(note);
    }
  );

  $("[js-minicart-popup]").on(
    "click",
    ".js-accordion-item-popup",
    function (event) {
      /* Act on the event */
      var el = $(this);
      el.toggleClass("show-body");
    }
  );
});
